import * as Yup from 'yup';

/*
	https://github.com/jquense/yup

	Função nullable() para aceitar valores nulos

	Função when() é como se fosse uma condicional,
	recebe o nome da variavel que será usada na condição,
	se for do tipo especificado no 'is', ele executa o 'then'
*/

export const CadastrarOficioValidationSchema = Yup.object().shape({
	tipoOficio: Yup.string().required('Campo obrigatório'),
	municipio: Yup.string().nullable().when(['tipoOficio'], {
		is: tipoOficio => tipoOficio === 'municipio',
		then: Yup.string().required('Campo obrigatório'),
	}),
	entidade: Yup.string().nullable().when(['tipoOficio'], {
		is: tipoOficio => tipoOficio === 'entidade',
		then: Yup.string().required('Campo obrigatório'),
	}),
	documento: Yup.string().nullable().required('Campo obrigatório'),
}, [['tipoOficio', 'municipio'], ['tipoOficio', 'entidade']]);
